var _g, _g2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradesPosition2Image(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1820_2193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6244 50.2295L10.8433 39.6148L10.8433 18.3853L29.6244 7.77054L48.4055 18.3853L48.4055 39.6148L29.6244 50.2295Z",
    fill: "#CC8CFB",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9055 39.323L29.6244 49.6552L11.3433 39.323L11.3433 18.677L29.6244 8.34488L47.9055 18.677L47.9055 39.323Z",
    stroke: "url(#paint0_linear_1820_2193)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1820_2193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 47.3853L7.93788 29L18.7812 10.6147L40.4677 10.6147L51.311 29L40.4677 47.3853L18.7812 47.3853Z",
    fill: "#CC8CFB",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1798 46.8893L19.0737 46.8893L8.5206 28.996L19.069 11.1107L40.1752 11.1107L50.7283 29.004L40.1798 46.8893Z",
    stroke: "url(#paint1_linear_1820_2193)",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8384 31.3875C27.7344 30.6408 28.4484 30.0202 28.9804 29.5255C29.5124 29.0215 29.9557 28.4988 30.3104 27.9575C30.6651 27.4162 30.8424 26.8842 30.8424 26.3615C30.8424 25.8855 30.7304 25.5122 30.5064 25.2415C30.2824 24.9708 29.9371 24.8355 29.4704 24.8355C29.0037 24.8355 28.6444 24.9942 28.3924 25.3115C28.1404 25.6195 28.0097 26.0442 28.0004 26.5855L26.0964 26.5855C26.1337 25.4655 26.4651 24.6162 27.0904 24.0375C27.7251 23.4588 28.5277 23.1695 29.4984 23.1695C30.5624 23.1695 31.3791 23.4542 31.9484 24.0235C32.5177 24.5835 32.8024 25.3255 32.8024 26.2495C32.8024 26.9775 32.6064 27.6728 32.2144 28.3355C31.8224 28.9982 31.3744 29.5768 30.8704 30.0715C30.3664 30.5568 29.7084 31.1448 28.8964 31.8355L33.0264 31.8355L33.0264 33.4595L26.1104 33.4595L26.1104 32.0035L26.8384 31.3875Z",
    fill: "#FBD365"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1820_2193",
    x: 6.84326,
    y: 7.77051,
    width: 45.5622,
    height: 50.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1820_2193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1820_2193",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1820_2193",
    x: 3.93787,
    y: 10.6147,
    width: 51.3731,
    height: 44.7705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1820_2193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1820_2193",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1820_2193",
    x1: 29.6244,
    y1: 50.2295,
    x2: 29.6244,
    y2: 7.77054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC8CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E09F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1820_2193",
    x1: 18.7812,
    y1: 47.3853,
    x2: 39.7822,
    y2: 10.2273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC8CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E09F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradesPosition2Image);
export default __webpack_public_path__ + "static/media/TradesPosition2Image.5d9433bbcecf1fe9100c9250d63aaca6.svg";
export { ForwardRef as ReactComponent };